import * as constants from "./../constants";

export default {
  title: "Špajza",
  language: "SK",
  navigation: {
    [constants.ROUTE_HOME]: "Domov",
    [constants.ROUTE_LOGIN]: "Prihlásenie",
    [constants.ROUTE_LOGOUT]: "@:user.logoutNotice.logoutButton",
    [constants.ROUTE_REGISTER]: "Registrácia",
    [constants.ROUTE_CATEGORIES]: "Kategórie",
    [constants.ROUTE_CATEGORY_DETAIL]: "Kategória",
    [constants.ROUTE_CATEGORY_EDIT]: "Upraviť kategóriu",
    [constants.ROUTE_NEW_CATEGORY]: "Nová kategória",
    [constants.ROUTE_FOOD]: "Potraviny",
    [constants.ROUTE_FOOD_EDIT]: "Upraviť potravinu",
    [constants.ROUTE_NEW_FOOD]: "Nová potravina"
  },
  buttons: {
    back: "Späť",
    cancel: "Zrušiť",
    create: "Vytvoriť",
    edit: "Upraviť",
    delete: "Zmazať",
    save: "Uložiť"
  },
  home: {
    welcome: "Vitajte vo Vašej špajzi!",
    about:
      "Špajza je online nástroj na sledovanie stavu potravín vo Vašej špajzi. Takže nabudúce, keď Vás v nedeľu večer budú mamy vyprevádzať do veľkého mesta s plným kufrom zaváranín, budete vedieť, čo Vám v Špajzi chýba a čoho máte dostatok.",
    loginPrompt:
      "Pre využitie funkcionality Špajze je potrebný používateľský účet, do ktorého budeme ukladať priebežný stav Vašich zásob v Špajzi. <br>Prihláste sa do svojho účtu alebo si založte nový tlačidlami nižsie."
  },
  categories: {
    edit: "Upraviť kategóriu <strong>{0}</strong>",
    recent: "Posledné kategórie",
    deleteConfirm:
      "Naozaj chcete zmazať kategóriu {0}?\nTáto kategória bude odobraná zo všetkých potravín, ku ktorým bola priradená."
  },
  food: {
    edit: "Upraviť potravinu <strong>{0}</strong>",
    recent: "Najnovšie potraviny",
    deleteConfirm: "Naozaj chcete zmazať {0}?"
  },
  user: {
    login: "Prihlásiť sa",
    register: "Založiť účet",
    logoutNotice: {
      header: "Čas Vášho prihlásenia čoskoro vyprší",
      text:
        "Automaticky Vás odhlásime o <strong>{0}</strong>.<br>Ak chcete zostať prihlásený, kliknite na tlačidlo nišie.",
      logoutButton: "Odhlásenie",
      stayButton: "Predĺžiť prihlásenie"
    }
  },
  forms: {
    amount: {
      label: "Množstvo",
      placeholder: "napr. 5",
      helper: ""
    },
    categories: {
      label: "Kategórie",
      placeholder: "Nie je zvolená žiadna kategória",
      helper:
        "Priraďte tejto položke ľubovoľný počet kategórií výberom z panelu napravo"
    },
    color: {
      label: "Farba",
      placeholder: "napr. e9521e",
      helper: "Zadajte RGB hexadecimálny kód"
    },
    email: {
      label: "Email",
      placeholder: "sp@j.za",
      helper: "Prihlasovacím menom do Špajze je Váš email"
    },
    name: {
      label: "Názov",
      placeholder: "Zadajte názov",
      helper: ""
    },
    notes: {
      label: "Poznámky",
      placeholder: "napr. Treba dokúpiť aspoň 5 kusov!!!",
      helper: "Hocičo potrebujete vedieť alebo pripomenúť si o tomto tovare"
    },
    pantryId: {
      label: "ID Špajze (nepovinné)",
      placeholder: "Unikátne ID Špajze založenej iným používateľom",
      helper:
        "Ak chcete zdieľat Špajzu s Vašim priateľom alebo členom rodiny, vložte sem ID Špajze existujúceho používateľa. V opačnom prípade Vám vytvoríme Vašu novú vlastnú Špajzu."
    },
    password: {
      label: "Heslo",
      placeholder: "",
      helper:
        "Heslo musí obsahovať aspoň jedno veľké písmeno, jedno malé písmeno a jednu číslicu. Minimálna dĺžka je 8 znakov."
    }
  },
  search: {
    placeholder: "jahodový džem",
    button: "Hľadať",
    noResultsFood: "Nenašli sa žiadne potraviny vyhovujúce hľadanému výrazu",
    noResultsCategories: "Nenašla sa žiadna kategória s názvom {0}"
  },
  sort: {
    order: "Zoradenie položiek",
    name: {
      asc: "Zoradiť podľa názvu vzostupne",
      desc: "Zoradiť podľa názvu zostupne"
    },
    updated: {
      asc: "Zobraziť naposledy aktualizované ako posledné",
      desc: "Zobraziť najskôr naposledy aktualizované"
    }
  }
};
